import GameParameterInterface from '@/models/game/parameters/interface'

export interface SlotLotteryParameter {
  prize: SlotGamePrize
  grade: number
}

interface SlotGamePrize {
  prizeImage: string,
}

export default class SlotParameter implements GameParameterInterface {
  constructor(private parameter: SlotLotteryParameter) { }

  createSetOption(): SlotLotteryParameter {
    return {
      prize: this.parameter.prize,
      grade: this.parameter.grade,
    }
  }

  get guideUrl(): string {
    return ''
  }
}
